import React from 'react'
import { getSteps } from './steps'
import { Step } from './Step'

export const TextFlow = ({ initialValues, completedStep, onChange, integrationComplete }) => {
    const steps = getSteps(initialValues)

    return (
        <>
            <div className="module-header">
                <h2>Part 1: How to Create a Custom App</h2>
            </div>
            {steps
                .filter((step, index) => index <= 4)
                .map((step, index) => (
                    <Step key={index} {...step} {...{ completedStep, onChange, integrationComplete }} />
                ))}

            <div className="module-header">
                <h2>Part 2: Select API scopes</h2>
            </div>
            {steps
                .filter((step, index) => index > 4 && index <= 9)
                .map((step, index) => (
                    <Step key={index} {...step} {...{ completedStep, onChange, integrationComplete }} />
                ))}

            <div className="module-header">
                <h2>Part 3: Install the app and get the API access tokens</h2>
            </div>
            {steps
                .filter((step, index) => index > 9)
                .map((step, index) => (
                    <Step key={index} {...step} {...{ completedStep, onChange, integrationComplete }} />
                ))}
        </>
    )
}
